import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "base-avatar-user" }
const _hoisted_2 = { class: "avatar" }
const _hoisted_3 = { class: "infos" }
const _hoisted_4 = {
  key: 0,
  class: "name ellipsis"
}
const _hoisted_5 = {
  key: 1,
  class: "type ellipsis"
}
const _hoisted_6 = { class: "arrow" }

import { ref, watchEffect } from "vue";
import { svgIcon } from "@/common/components";


export default /*@__PURE__*/_defineComponent({
  __name: 'user-avatar',
  props: {
    name: {},
    role: {},
    width: { default: "11rem" },
    open: { type: Boolean },
    fontSize: { default: "0.875rem" },
    size: { default: "2.5rem" }
  },
  setup(__props: any) {

_useCssVars(_ctx => ({
  "v48166f3f": (_ctx.size),
  "v8a20f370": (_ctx.width),
  "v5035612e": (_ctx.fontSize)
}))

const props = __props;

const showMenu = ref(false);

watchEffect(() => {
  showMenu.value = props.open;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(svgIcon), {
        icon: "person",
        size: "1.5rem"
      })
    ]),
    _createElementVNode("div", _hoisted_3, [
      (__props.name)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(__props.name), 1))
        : _createCommentVNode("", true),
      (__props.role)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(__props.role), 1))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_6, [
      (showMenu.value)
        ? (_openBlock(), _createBlock(_unref(svgIcon), {
            key: 0,
            icon: "arrow-up",
            size: "1rem"
          }))
        : (_openBlock(), _createBlock(_unref(svgIcon), {
            key: 1,
            icon: "arrow-down",
            size: "1rem"
          }))
    ])
  ]))
}
}

})